<template>
	<div>
		<h2 class="text-center text-[20px] leading-[28px] font-semibold text-gray-900">
			Special Offer!
		</h2>
		<p class="mt-0.5 text-center text-[14px] leading-[20px] font-normal text-gray-500">
			Since you have been with us a while, here is a special discount for you!
			Stay and save 30% for the next 3 months.
		</p>

		<div class="relative mt-4 h-[128px] w-full">
			<!-- The perforated ticket frame and its watermark, exported from Figma. -->
			<img
				:src="TICKET_IMAGE"
				alt=""
				class="absolute inset-0 size-full"
			/>

			<div class="absolute inset-0 flex flex-col items-center justify-center gap-2">
				<div class="text-center">
					<p class="text-[12px] leading-[16px] font-medium text-gray-500">
						Limited Time Offer
					</p>
					<p class="text-[24px] leading-[32px] font-semibold text-gray-900">
						30% Off for 3 Months
					</p>
				</div>

				<button
					type="button"
					:disabled="isSubmitting"
					class="
						flex h-9 items-center justify-center rounded-md bg-won-green px-6
						text-[16px] leading-[20px] font-medium text-white
						hover:bg-won-green-dark disabled:cursor-default
					"
					@click="emit('accept')"
				>
					<template v-if="isSubmitting">
						<LoadingIcon margin="" />
					</template>
					<template v-else>
						Accept This Offer
					</template>
				</button>
			</div>
		</div>

		<button
			type="button"
			class="
				mx-auto mt-4 flex h-9 w-full max-w-[320px] items-center justify-center rounded-md
				bg-gray-100 px-3 text-[16px] leading-[20px] font-medium text-gray-900 hover:bg-gray-200
			"
			@click="emit('decline')"
		>
			Decline Offer
		</button>
	</div>
</template>

<script setup>
import LoadingIcon from '../../../../icons/loading-spinner.vue';

// Served from public/, so it is referenced as a runtime path rather than a Vite import.
const TICKET_IMAGE = '/img/cancellation-offer-ticket.svg';

defineProps({
	isSubmitting: {
		type: Boolean,
		default: false,
	},
});

const emit = defineEmits(['accept', 'decline']);
</script>
